module.exports = __webpack_public_path__ + "img/pingyuanxinqu.401cc0f4.png";